import { toastError } from '../utils/toastMessage';
import { RESET_CBGU, GET_CALCULATE_CBGU_SUCCESS } from '../constants/constants';
import API from '../utils/API';

export const getCalculateCBGUSuccess = (data) => {
  return {
    type: GET_CALCULATE_CBGU_SUCCESS,
    data,
  };
};

export const updateComplexAvgCalories = (complexId, avgCalories) => {
  return () => {
    API.post(`/complexes/${complexId}/edit`, {
      avg_calories: avgCalories,
    })
      .then(() => {})
      .catch(() => {
        toastError();
      });
  };
};

export const getCalculateCBGU = ({ age, height, weight, activity_id, gender_id }) => {
  if (weight < 40 || weight > 300 || height < 100 || height > 250 || age < 18 || age > 90) {
    return (dispatch) => dispatch({ type: RESET_CBGU });
  }
  return (dispatch) => {
    API.post('/users/calculate', {
      age,
      weight,
      height,
      activity: activity_id,
      gender: gender_id !== 1 ? gender_id : 3, // set default female gender
    })
      .then((response) => {
        dispatch(getCalculateCBGUSuccess(response.data.data.CPFC));
      })
      .catch(() => {
        dispatch({ type: RESET_CBGU });
        toastError('Просчет калорий не удался');
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/calculateCbgu.js